export const CANCEL_POPUP_DATA = {
    title: 'Отменить создание лида?',
    width: 384,
    subButtonText: 'Да',
    mainButtonText: 'Нет',
    subText: 'Данные не будут сохранены',
};

export const INDIVIDUAL = 'ИП';